import React, { useState } from "react";
import logo from "../Assets/ti_logo.jpg";
import { EsseCloseCircleO } from "lovedicons/dist/esseO";
import { ax_auth_addUser } from "../api/auth";
import toast from "react-hot-toast";

const Adduser = ({ onClose }) => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    phone: "",
    userID: "",
    password: "",
    isFocused: {
      name: false,
      email: false,
      phone: false,
      userID: false,
      password: false,
    },
  });

  const [errors, setErrors] = useState({});

  const handleFocus = (field) => {
    setUserData((prev) => ({
      ...prev,
      isFocused: { ...prev.isFocused, [field]: true },
    }));
  };

  const handleBlur = (field) => {
    setUserData((prev) => ({
      ...prev,
      isFocused: { ...prev.isFocused, [field]: prev[field].trim() !== "" },
    }));
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [id]: value,
      isFocused: { ...prev.isFocused, [id]: true },
    }));
  };

  const validateForm = () => {
    const validationErrors = {};
    const { name, email, phone, userID, password } = userData;

    if (!name.trim()) {
      validationErrors.name = "Name is required.";
      // toast.error("Name is required!");
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email.trim()) {
      validationErrors.email = "Email is required.";
      // toast.error("Email is required!");
    } else if (!emailPattern.test(email)) {
      validationErrors.email = "Invalid email format.";
      // toast.error("Invalid email format!");
    }

    const phonePattern = /^[0-9]{10}$/;
    if (!phone.trim()) {
      validationErrors.phone = "Phone number is required.";
      // toast.error("Phone number is required!");
    } else if (!phonePattern.test(phone)) {
      validationErrors.phone = "Invalid phone number.";
      // toast.error("Invalid phone number! It must be 10 digits.");
    }

    if (!userID.trim()) {
      validationErrors.userID = "User ID is required.";
      // toast.error("User ID is required!");
    }

    if (!password.trim()) {
      validationErrors.password = "Password is required.";
      // toast.error("Password is required!");
    } else if (password.length < 6) {
      validationErrors.password = "Password must be at least 6 characters.";
      // toast.error("Password must be at least 6 characters!");
    }

    return validationErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return; // **Stop execution if validation fails**
    }

    const data = {
      name: userData.name,
      email: userData.email,
      phone: userData.phone,
      userId: userData.userID,
      password: userData.password, // ✅ Fixed field name
    };

    try {
      const axAddUser = await ax_auth_addUser(data);
      console.log("axAddUser - ", axAddUser);

      if (axAddUser && axAddUser.success) {
        toast.success("User created successfully!");
        setErrors({});
        setUserData({
          name: "",
          email: "",
          phone: "",
          userID: "",
          password: "",
          isFocused: {
            name: false,
            email: false,
            phone: false,
            userID: false,
            password: false,
          },
        });
        onClose();
      } else {
        toast.error(
          axAddUser?.response?.data?.description || "Failed to create user."
        );
      }
    } catch (error) {
      console.error("Error while creating user:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  // const validateForm = () => {
  //   const validationErrors = {};
  //   const { name, email, phone, userID, password } = userData;

  //   if (!name.trim()) validationErrors.name = "Name is required.";
  //   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //   if (!email.trim()) validationErrors.email = "Email is required.";
  //   else if (!emailPattern.test(email))
  //     validationErrors.email = "Invalid email format.";

  //   const phonePattern = /^[0-9]{10}$/;
  //   if (!phone.trim()) validationErrors.phone = "Phone number is required.";
  //   else if (!phonePattern.test(phone))
  //     validationErrors.phone = "Invalid phone number.";

  //   if (!userID.trim()) validationErrors.userID = "User ID is required.";
  //   if (!password.trim()) validationErrors.password = "Password is required.";
  //   else if (password.length < 6)
  //     validationErrors.password = "Password must be at least 6 characters.";

  //   return validationErrors;
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const formErrors = validateForm();
  //   if (Object.keys(formErrors).length === 0) {
  //     // alert("User created successfully!");
  //     // Optionally, reset form here
  //     setUserData({
  //       name: "",
  //       email: "",
  //       phone: "",
  //       userID: "",
  //       password: "",
  //       isFocused: {
  //         name: false,
  //         email: false,
  //         phone: false,
  //         userID: false,
  //         password: false,
  //       },
  //     });
  //     setErrors({});
  //   } else {
  //     setErrors(formErrors);
  //   }
  //   const data = {
  //     name: userData.name,
  //     email: userData.email,
  //     phone: userData.phone,
  //     userId: userData.userID,
  //     passWord: userData.password,
  //   };
  //   // console.log("Data", data);

  //   // const response = await APICall.post(
  //   //   "https://node-ticycles-warranty.vercel.app/addUser/addUserData",
  //   //   { data }
  //   // );
  //   // console.log("response", response);

  //   const axAddUser = await ax_auth_addUser(data);

  //   console.log("axAddUser - ", axAddUser);
  //   if (axAddUser && axAddUser.success) {
  //   } else {
  //     toast.error(axAddUser?.response?.data?.description);
  //   }
  // };

  // useEffect(()=>{
  //   UserData()
  // },[userData])

  return (
    <section className="flex items-center justify-center min-h-screen bg-black bg-opacity-50 fixed inset-0 z-50">
      <div className="relative p-10 shadow-lg rounded-md bg-white w-full max-w-2xl max-h-[80vh] overflow-auto">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-800 focus:outline-none"
          onClick={onClose}
        >
          <EsseCloseCircleO className="w-6 md:w-7 h-6 md:h-7" />
        </button>

        {/* Centered Logo */}
        <div className="flex mb-3 justify-center">
          <img src={logo} alt="Montra Logo" className="w-[100px] h-auto" />
        </div>

        {/* Title */}
        <div className="text-left mb-6">
          <div className="text-2xl font-semibold text-gray-600 text-center">
            Add New User
          </div>
        </div>

        {/* Form */}
        <form className="grid gap-6 w-full" onSubmit={handleSubmit}>
          {["name", "email", "phone", "userID", "password"].map((field) => (
            <div key={field} className="relative">
              <label
                className={`absolute left-3 transition-all duration-300 ${
                  userData.isFocused[field] || userData[field]
                    ? "-top-[14px] left-3 text-blue-500 text-[16px] bg-white px-1"
                    : "top-3 text-gray-500"
                }`}
              >
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </label>
              <input
                type={field === "password" ? "password" : "text"}
                id={field}
                className={`w-full p-3 rounded-md border focus:outline-none transition-transform duration-300 ${
                  userData.isFocused[field] || userData[field]
                    ? "bg-white border-blue-500"
                    : "bg-gray-100 border-gray-300"
                }`}
                value={userData[field]}
                onFocus={() => handleFocus(field)}
                onBlur={() => handleBlur(field)}
                onChange={handleChange}
                aria-label={field.charAt(0).toUpperCase() + field.slice(1)}
              />
              {errors[field] && (
                <span className="text-red-500 text-sm mt-1">
                  {errors[field]}
                </span>
              )}
            </div>
          ))}

          {/* Submit Button */}
          <div className="text-center mt-4">
            <button
              type="submit"
              className="w-32 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Adduser;
